export default function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ramda@0.25.0@ramda/es/internal/_forceReduced.js
// module id = 873
// module chunks = 378